module.exports = __webpack_public_path__ + "img/emoje.783b3470.png";